<template>
  <v-main>
    <v-container fluid>
      <v-row justify="center">
        <v-col md="12" lg="12" sm="12" class="px-0">
          <v-btn
            fab
            x-small
            class="mx-2 mb-2"
            color="white"
            @click="$router.back()"
          >
            <v-icon light> mdi-arrow-left </v-icon>
          </v-btn>
          <!-- Main Container -->
          <v-card class="mt-4" rounded="xl" color="blue lighten-5" width="auto">
            <!-- Dashboard Container -->
            <v-container fluid>
              <v-row class="pt-4">
                <v-col>
                  <v-toolbar-title class="text-h4 blue--text">
                    Operation Team
                  </v-toolbar-title>
                </v-col>
              </v-row>
              <!-- Role Cards -->
              <v-row class="mt-4">
                <v-col
                  cols="12"
                  sm="6"
                  md="4"
                  v-for="role in roles"
                  :key="role"
                >
                  <v-card
                    class="count-card pa-4"
                    rounded="lg"
                    color="white"
                    elevation="2"
                    :to="`/master/attendances/operation-team/attendances?category=${role}`"
                  >
                    <v-card-title class="justify-center blue--text">
                      {{ role }}
                    </v-card-title>
                  </v-card>
                </v-col>
              </v-row>
            </v-container>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    <v-container class="footer-text">
      <v-row justify="center">
        <v-col align="center">
          <h3 class="white--text">We Alliance Sparkle</h3>
          <h4 class="white--text">v 1.0.0</h4>
        </v-col>
      </v-row>
    </v-container>
  </v-main>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      roles: [
        "Operation Manager",
        "Rounder Supervisor",
        "Area Supervisor",
        "Site Supervisor",
        "HK Boy",
        "Back Office",
      ],
    };
  },

  methods: {
    navigateTo(route) {
      this.$router.push(route);
    },
  },
};
</script>

<style scoped>
@media (max-width: 959px) {
  .count-card {
    flex: 0 0 50% !important;
    max-width: 50% !important;
  }
}
</style>
